import React from 'react';
import PropTypes from 'prop-types';
import ProductAddOnIneligible from './components/ProductAddOnIneligible';
import ProductAddOnAvailable from './components/ProductAddOnAvailable';
import { modify } from '../../helpers/classNameHelper';


const ProductAddOn = (props) => {
  const {
    addOn: {
      status: {
        eligible,
      },
    },
    isTile,
    styleFlag,
  } = props;

  const className = modify('product-addon', {
    'promo-tile': isTile && eligible,
    styleFlag,
  });

  const Component = eligible ? ProductAddOnAvailable : ProductAddOnIneligible;

  return (
    <div className={className}>
      <Component {...props} />
    </div>
  );
};

ProductAddOn.propTypes = {
  addOn: PropTypes.shape({
    status: PropTypes.shape({
      eligible: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  isTile: PropTypes.bool,
  styleFlag: PropTypes.string,
};

ProductAddOn.defaultProps = {
  isTile: false,
  styleFlag: null,
};


export default ProductAddOn;
